export default __webpack_public_path__ + "static/media/milluu-carefree.33aca3ce.svg";